var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat-bot-icon",on:{"click":function($event){return _vm.openChatBot()}}},[_c('BnIcon',{attrs:{"name":"message-chatbot","size":"32"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }